import { render, staticRenderFns } from "./ServiceIconList.vue?vue&type=template&id=fd88d62c&"
import script from "./ServiceIconList.vue?vue&type=script&lang=js&"
export * from "./ServiceIconList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports